import { render, staticRenderFns } from "./alerts.vue?vue&type=template&id=4bd861cf&scoped=true"
import script from "./alerts.vue?vue&type=script&lang=js"
export * from "./alerts.vue?vue&type=script&lang=js"
import style0 from "./alerts.styl?vue&type=style&index=0&id=4bd861cf&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd861cf",
  null
  
)

export default component.exports